module.exports = __webpack_public_path__ + "static/e7c4b231-76ad-47c7-a54b-5d84dcd78d0f-86bef86541a27161bb5e7894ec56420f.woff";